import {
  ThumbUp as AcceptIcon,
  ThumbDown as DeclineIcon,
  Close as RemoveIcon,
} from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import {
  acceptIconSx,
  actionButtonSx,
  compactButtonsContainerSx,
  declineIconSx,
  expandedButtonsContainerSx,
} from './SuggestedDocumentReference.styles';

interface SuggestionActionButtonsProps {
  acceptLabel?: string;
  dismissLabel?: string;
  onAccept?: () => void;
  onDecline?: () => void;
  removeLabel?: string;
  onRemove?: () => void;
  centered?: boolean;
}

const SuggestionActionButtons = ({
  acceptLabel,
  dismissLabel = 'Dismiss',
  onAccept,
  onDecline,
  removeLabel = 'Remove',
  onRemove,
  centered,
}: SuggestionActionButtonsProps) => (
  <Box sx={centered ? expandedButtonsContainerSx : compactButtonsContainerSx}>
    {onAccept && onDecline ? (
      <>
        <Button
          variant="outlined"
          size="small"
          onClick={onAccept}
          endIcon={<AcceptIcon sx={acceptIconSx} />}
          sx={actionButtonSx}
        >
          {acceptLabel}
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={onDecline}
          endIcon={<DeclineIcon sx={declineIconSx} />}
          sx={actionButtonSx}
        >
          {dismissLabel}
        </Button>
      </>
    ) : (
      onRemove && (
        <Button
          variant="outlined"
          size="small"
          onClick={onRemove}
          endIcon={<RemoveIcon sx={declineIconSx} />}
          sx={actionButtonSx}
        >
          {removeLabel}
        </Button>
      )
    )}
  </Box>
);

export default SuggestionActionButtons;
